// extracted by mini-css-extract-plugin
export default {"search":"_2e5yT","searchInputWrapper":"FZ_Gd","mxSearchInputWrapper":"_2mycU","searchIcon":"_2ka0G"};